import React, { Component } from 'react';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import i18n from '../../i18n';
// const exampleResponse = {
//     "code": "SUCCESS",
//     "error": "OK",
//     "data": [
//         {
//             "id": 102,
//             "gateway": {
//                 "id": 115,
//                 "name": "stubp2p",
//                 "isArchived": false,
//                 "flag": "p2p",
//                 "method": "ru-sbp-classic"
//             },
//         },
//         {
//             "id": 143,
//             "gateway": {
//                 "id": 115,
//                 "name": "stubp2p",
//                 "isArchived": false,
//                 "flag": "p2p",
//                 "method": "ru-sbp-classic"
//             },
//         }
//     ],
//     "total_count": 2
// };
export class DisplayP2pMethodsDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            methods: [],
            error: null
        };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        const Server =
            this.props.context?.getState()?.server?.publicMerchantTerminalGateways;
        if (!Server) {
            this.setState({ loading: false, error: 'Server not available' });
            return;
        }

        try {
            this.setState({ loading: true, error: null });
            const filter = [
                [
                    { field: 'merchantTerminal.id', op: '=', value: this.props.value },
                    { field: 'gateway.flag', op: '=', value: 'p2p' }
                ]
            ];
            const res = await Server.getAllFiltered(filter);
            // const res = exampleResponse; // For testing without server
            const parsed = this.parseResponse(res);
            this.setState({ methods: parsed, loading: false });
        } catch (e) {
            this.setState({ error: e.message || 'Error loading data', loading: false });
        }
    }

    parseResponse(res) {
        if (!res || !res.data) return [];
        return res.data
            .filter((item) => item.isActive && item.gateway?.method)
            .map((item) => item.gateway.method);
    }

    render() {
        const { loading, methods } = this.state;

        if (loading)
            return (
                <Box sx={{ m: 1 }}>
                    <Typography variant="subtitle1">
                        {i18n.t(`columns.p2pMethods`)}
                    </Typography>
                    <Stack spacing={1}>
                        <Skeleton variant="text" width="60%" />
                    </Stack>
                </Box>
            );

        if (methods.length === 0)
            return (<Box sx={{ m: 1 }}>
                <Typography variant="subtitle1">
                    {i18n.t(`columns.p2pMethods`)}
                </Typography>
                <Typography variant="body2">
                    No available P2P methods
                </Typography>
            </Box>);

        return (
            <Box sx={{ m: 1 }}>
                <Typography variant="subtitle1">
                    {i18n.t(`columns.p2pMethods`)}
                </Typography>
                <Typography variant="body1">
                    Available P2P methods: <strong> {methods.join(', ')} </strong>
                </Typography>
            </Box>

        );
    }
}

